import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from 'xlsx';
import useApi from "../../../CustomHooks/useApi";
import { Search } from "lucide-react";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";

const isSameDate = (dateStr, targetDate) => {
  const d = new Date(dateStr);
  return (
    d.getFullYear() === targetDate.getFullYear() &&
    d.getMonth() === targetDate.getMonth() &&
    d.getDate() === targetDate.getDate()
  );
};

const isBetweenDates = (dateStr, from, to) => {
  const d = new Date(dateStr);
  const fromD = new Date(from);
  const toD = new Date(to);

  // include entire end day
  toD.setHours(23, 59, 59, 999);

  return d >= fromD && d <= toD;
};

const RetailerCashiInReport = () => {
  const mid = useSelector((state) => state.auth.employeeDetails?.username);
  const [history, setHistory] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [creditbalance, setCreditbalance] = useState(0);
  const [debitbalance, setDebitbalance] = useState(0);
  const [refundbalance, setRefundbalance] = useState(0);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [selectedBalance, setSelectedBalance] = useState('');
  const { callApi: ledgerreport } = useApi("/business/wallet/ledger", "GET");

  // const fetchPayoutHistory = async (type) => {
  //   setIsHistoryLoading(true);

  //   const typeParam = type ? `&filterType=${type}` : "";
  //   const queryParams = `?bid=${mid}&fromDate=${fromDate}&toDate=${toDate}${typeParam}`;

  //   try {
  //     const response = await ledgerreport(null, queryParams);
  //     const ledgerData = response.ledgerResponses || [];

  //     // ===== APPLY DATE FILTER (TABLE + TOTALS) =====
  //     let filteredData = [];

  //     if (fromDate && toDate) {
  //       filteredData = ledgerData.filter(tx =>
  //         isBetweenDates(tx.transactionDate, fromDate, toDate)
  //       );
  //     } else {
  //       const today = new Date();
  //       filteredData = ledgerData.filter(tx =>
  //         isSameDate(tx.transactionDate, today)
  //       );
  //     }

  //     // ===== APPLY TYPE FILTER (IF CLICKED) =====
  //     // if (type) {
  //     //   filteredData = filteredData.filter(tx => tx.type === type);
  //     // }
  //     if (type) {
  //       filteredData = filteredData.filter(tx => tx.type === type);
  //     }

  //     // ===== KEEP ONLY BUSINESS_CASH_OUT CATEGORY =====
  //     filteredData = filteredData.filter(
  //       tx => tx.category === "BUSINESS_CASH_IN"
  //     );

  //     // ===== CALCULATE TOTALS FROM FILTERED DATA =====
  //     const creditTotal = filteredData
  //       .filter(tx => tx.type === "CREDIT")
  //       .reduce((sum, tx) => sum + Number(tx.txnAmount || 0), 0);

  //     const debitTotal = filteredData
  //       .filter(tx => tx.type === "DEBIT")
  //       .reduce((sum, tx) => sum + Number(tx.txnAmount || 0), 0);

  //     const refundTotal = filteredData
  //       .filter(tx => tx.type === "REFUND")
  //       .reduce((sum, tx) => sum + Number(tx.txnAmount || 0), 0);

  //     setCreditbalance(creditTotal.toFixed(2));
  //     setDebitbalance(debitTotal.toFixed(2));
  //     setRefundbalance(refundTotal.toFixed(2));

  //     // ===== SORT & SET TABLE DATA (FILTERED ONLY) =====
  //     const sortedData = filteredData.sort(
  //       (a, b) => new Date(b.transactionDate) - new Date(a.transactionDate)
  //     );
  //     setHistory(sortedData);

  //     setCurrentPage(1);

  //   } catch (error) {
  //     console.error("Error fetching distributor ledger:", error);
  //     alert("Failed to load ledger report.");
  //   } finally {
  //     setIsHistoryLoading(false);
  //   }
  // };


  const fetchPayoutHistory = async (
    type = "",
    pageNo = 0,
    isLoadMore = false
  ) => {
    setIsHistoryLoading(true);

    const queryParams =
      `?bid=${mid}` +
      `&fromDate=${fromDate}` +
      `&toDate=${toDate}` +
      `&filterType=BUSINESS_CASH_IN` +
      `${type ? `&filterType=${type}` : ""}` +
      `&page=${pageNo}` +
      `&size=10`;

    try {
      const response = await ledgerreport(null, queryParams);
      const ledgerData = response.ledgerResponses || [];

      // sort latest first
      const sortedData = ledgerData.sort(
        (a, b) => new Date(b.transactionDate) - new Date(a.transactionDate)
      );

      setHistory(prev =>
        isLoadMore ? [...prev, ...sortedData] : sortedData
      );

      setPage(pageNo);
      setHasMore(pageNo < response.totalPages - 1);

      // totals directly from backend
      setCreditbalance(Number(response.totalCredit || 0).toFixed(2));
      setDebitbalance(Number(response.totalDebit || 0).toFixed(2));
      setRefundbalance(Number(response.totalRefund || 0).toFixed(2));

    } catch (err) {
      console.error(err);
      alert("Failed to load ledger");
    } finally {
      setIsHistoryLoading(false);
    }
  };

  const filteredRecords = history.filter((record) =>
    Object.values(record).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalFilteredTxnAmount = filteredRecords.reduce(
    (sum, record) => sum + Number(record.txnAmount || 0),
    0
  );


  // useEffect(() => {
  //   fetchPayoutHistory("");
  // }, []);
  // useEffect(() => {
  //   const todayStr = new Date().toISOString().split("T")[0];
  //   setFromDate(todayStr);
  //   setToDate(todayStr);
  //   fetchPayoutHistory("");
  // }, []);

  useEffect(() => {
    const todayStr = new Date().toISOString().split("T")[0];
    setFromDate(todayStr);
    setToDate(todayStr);

    fetchPayoutHistory("", 0, false);
  }, []);


  useEffect(() => {
    if (selectedBalance !== "") {
      fetchPayoutHistory(selectedBalance);
    }
  }, [selectedBalance]);



  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  const downloadExcel = () => {
    const headers = ["Date", "TxnID", "BusinessLedgerId", "OperatorId", "Type", "PreBalance", "TxnAmount", "PostBalance", "Category", "Narration", "RetailerShop"];
    const formattedHistory = history.map(record => ({
      Date: record.transactionDate,
      TxnID: record.trans_id,
      BusinessLedgerId: record.id,
      OperatorId: record.operatorRefNumber,
      Type: record.type,
      PreBalance: record.preBalance,
      TxnAmount: record.txnAmount,
      PostBalance: record.postBalance,
      Category: record.category,
      Narration: record.narration,
      RetailerShop: record.shopName

    }));
    const ws = XLSX.utils.json_to_sheet(formattedHistory, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    XLSX.writeFile(wb, "transaction_history.xlsx");
  };

  // const handleBalanceClick = (type) => {
  //   setSelectedBalance(type);
  //   setCurrentPage(1);
  // }

  const handleBalanceClick = (type) => {
    setSelectedBalance(type);
    setHistory([]);
    fetchPayoutHistory(type, 0, false);
  };


  // const handleSearch = () => {
  //   if (!fromDate || !toDate) {
  //     alert("Please select both From and To dates.");
  //     return;
  //   }
  //   setCurrentPage(1);
  //   fetchPayoutHistory(selectedBalance);
  // };

  const handleSearch = () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }
    setHistory([]);
    fetchPayoutHistory(selectedBalance, 0, false);
  };



  // const handleclear = () => {
  //   setCurrentPage(1);
  //   setSelectedBalance("");
  //   setFromDate("");
  //   setToDate("")
  //   fetchPayoutHistory();
  // }
  // const handleclear = () => {
  //   const todayStr = new Date().toISOString().split("T")[0];
  //   setFromDate(todayStr);
  //   setToDate(todayStr);
  //   setSelectedBalance("");
  //   setCurrentPage(1);
  //   fetchPayoutHistory("");
  // };

  const handleclear = () => {
    const todayStr = new Date().toISOString().split("T")[0];
    setFromDate(todayStr);
    setToDate(todayStr);
    setSelectedBalance("");
    setHistory([]);
    fetchPayoutHistory("", 0, false);
  };

  const handleLoadMore = () => {
    if (!isHistoryLoading && hasMore) {
      fetchPayoutHistory(
        selectedBalance,
        page + 1,
        true
      );
    }
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-indigo-50 to-cyan-50 p-6">
      <div className="max-w-7xl mx-auto space-y-8">

        {/* ===== HEADER ===== */}
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">
            Retailer Cashi In Report
          </h1>
          <p className="text-sm text-slate-600 mt-1">
            Detailed wallet credit, debit and refund history
          </p>
        </div>

        {/* ===== FILTERS CARD ===== */}
        <div
          className="rounded-3xl p-6 bg-slate-100
        shadow-[8px_8px_20px_rgba(0,0,0,0.12),_-8px_-8px_20px_rgba(255,255,255,0.9)]"
        >
          <div className="flex flex-col xl:flex-row gap-6 xl:items-center justify-between">

            {/* SEARCH */}
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="text"
                placeholder="Search by Txn ID, category, shopName or narration"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-11 pr-4 py-3 rounded-xl bg-slate-100 shadow-inner
              focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            {/* DATE FILTERS */}
            <div className="flex flex-wrap items-center gap-4">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="px-4 py-3 rounded-xl bg-slate-100 shadow-inner
              focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="px-4 py-3 rounded-xl bg-slate-100 shadow-inner
              focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />

              <button
                onClick={handleSearch}
                className="px-6 py-3 rounded-xl
              bg-gradient-to-r from-indigo-600 to-cyan-500
              text-white font-semibold shadow-lg hover:shadow-xl"
              >
                Search
              </button>

              <button
                onClick={handleclear}
                className="px-6 py-3 rounded-xl
              bg-slate-200 text-slate-700 font-semibold
              hover:bg-slate-300"
              >
                Clear
              </button>

              <button
                onClick={downloadExcel}
                className="px-6 py-3 rounded-xl
              bg-emerald-500 text-white font-semibold
              shadow-lg hover:shadow-xl"
              >
                Download Excel
              </button>
            </div>
          </div>
        </div>

        {/* ===== BALANCE SUMMARY ===== */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <button
            onClick={() => handleBalanceClick("CREDIT")}
            className={`rounded-2xl p-5 text-left transition
            ${selectedBalance === "CREDIT"
                ? "bg-gradient-to-br from-indigo-600 to-cyan-500 text-white shadow-lg"
                : "bg-slate-100 text-slate-800 shadow-inner"
              }`}
          >
            <p className="text-sm opacity-80">Total Credit</p>
            <p className="text-2xl font-semibold">₹ {creditbalance}</p>
          </button>

          <button
            onClick={() => handleBalanceClick("DEBIT")}
            className={`rounded-2xl p-5 text-left transition
            ${selectedBalance === "DEBIT"
                ? "bg-gradient-to-br from-rose-500 to-red-600 text-white shadow-lg"
                : "bg-slate-100 text-slate-800 shadow-inner"
              }`}
          >
            <p className="text-sm opacity-80">Total Debit</p>
            <p className="text-2xl font-semibold">₹ {debitbalance}</p>
          </button>

          <button
            onClick={() => handleBalanceClick("REFUND")}
            className={`rounded-2xl p-5 text-left transition
            ${selectedBalance === "REFUND"
                ? "bg-gradient-to-br from-amber-400 to-yellow-500 text-white shadow-lg"
                : "bg-slate-100 text-slate-800 shadow-inner"
              }`}
          >
            <p className="text-sm opacity-80">Total Refund</p>
            <p className="text-2xl font-semibold">₹ {refundbalance}</p>
          </button>
        </div>

        {/* ===== TABLE ===== */}
        <div
          className="rounded-3xl bg-slate-100 p-6
        shadow-[8px_8px_20px_rgba(0,0,0,0.12),_-8px_-8px_20px_rgba(255,255,255,0.9)]"
        >
          {/* <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-slate-600">
                  {["Date/Time", "Txn ID", "Business Ledger Id", "Operator Id", "Type", "Pre Balance", "Txn Amount", "Post Balance", "Category", "Narration"].map(
                    (h) => (
                      <th key={h} className="py-3 px-4 font-semibold">
                        {h}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-200">
                {isHistoryLoading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-6">
                      Loading...
                    </td>
                  </tr>
                ) : currentRecords.length > 0 ? (
                  currentRecords.map((record, index) => (
                    <tr key={index} className="hover:bg-white/60 transition">
                      <td className="px-4 py-3">
                        {getDisplayDate(record.transactionDate)}
                      </td>
                      <td className="px-4 py-3">{record.trans_id || "—"}</td>
                      <td className="px-4 py-3">{record.id || "—"}</td>
                      <td className="px-4 py-3">{record.operatorRefNumber || "—"}</td>
                      <td className="px-4 py-3">{record.type}</td>
                      <td className="px-4 py-3">₹ {record.preBalance}</td>
                      <td className="px-4 py-3">₹ {record.txnAmount}</td>
                      <td className="px-4 py-3">₹ {record.postBalance}</td>
                      <td className="px-4 py-3">{record.category}</td>
                      <td className="px-4 py-3">{record.narration}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-6">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-slate-600">
                  {[
                    "Date/Time",
                    "Retailer Shop",
                    "Txn ID",
                    "Business Ledger Id",
                    "Operator Id",
                    "Type",
                    "Pre Balance",
                    "Txn Amount",
                    "Post Balance",
                    "Category",
                    "Narration",
                  ].map((h) => (
                    <th key={h} className="py-3 px-4 font-semibold">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-200">
                {isHistoryLoading ? (
                  <tr>
                    <td colSpan="10" className="text-center py-6">
                      Loading...
                    </td>
                  </tr>
                ) : currentRecords.length > 0 ? (
                  // currentRecords.map((record, index) => (
                  //   <tr key={index} className="hover:bg-white/60 transition">
                  //     <td className="px-4 py-3">{getDisplayDate(record.transactionDate)}</td>
                  //     <td className="px-4 py-3">{record.shopName}</td>
                  //     <td className="px-4 py-3">{record.trans_id || "—"}</td>
                  //     <td className="px-4 py-3">{record.id || "—"}</td>
                  //     <td className="px-4 py-3">{record.operatorRefNumber || "—"}</td>
                  //     <td className="px-4 py-3">{record.type}</td>
                  //     <td className="px-4 py-3">₹ {record.preBalance}</td>
                  //     <td className="px-4 py-3">₹ {record.txnAmount}</td>
                  //     <td className="px-4 py-3">₹ {record.postBalance}</td>
                  //     <td className="px-4 py-3">{record.category}</td>
                  //     <td className="px-4 py-3">{record.narration}</td>
                  //   </tr>
                  // ))
                  <>
                    {currentRecords.map((record, index) => (
                      <tr key={index} className="hover:bg-white/60 transition">
                        <td className="px-4 py-3">{getDisplayDate(record.transactionDate)}</td>
                        <td className="px-4 py-3">{record.shopName}</td>
                        <td className="px-4 py-3">{record.trans_id || "—"}</td>
                        <td className="px-4 py-3">{record.id || "—"}</td>
                        <td className="px-4 py-3">{record.operatorRefNumber || "—"}</td>
                        <td className="px-4 py-3">{record.type}</td>
                        <td className="px-4 py-3">₹ {record.preBalance}</td>
                        <td className="px-4 py-3">₹ {record.txnAmount}</td>
                        <td className="px-4 py-3">₹ {record.postBalance}</td>
                        <td className="px-4 py-3">{record.category}</td>
                        <td className="px-4 py-3">{record.narration}</td>
                      </tr>
                    ))}

                    {/* ===== TOTAL ROW ===== */}
                    <tr className="bg-slate-200 font-semibold">
                      <td colSpan={7} className="px-4 py-3 text-right">
                        Total
                      </td>
                      <td className="px-4 py-3">
                        ₹ {totalFilteredTxnAmount.toFixed(2)}
                      </td>
                      <td colSpan={3}></td>
                    </tr>
                  </>

                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-6">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ===== MOBILE CARD VIEW ===== */}
          <div className="block md:hidden space-y-4">
            {isHistoryLoading ? (
              <p className="text-center py-6">Loading...</p>
            ) : currentRecords.length > 0 ? (
              currentRecords.map((record, index) => (
                <div
                  key={index}
                  className="rounded-2xl bg-white p-4 shadow-md space-y-2"
                >
                  <div className="text-sm">
                    <p className="text-slate-500">Retailer Shop</p>
                    <p className="font-medium break-words">{record.shopName}</p>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Date</span>
                    <span className="font-medium">
                      {getDisplayDate(record.transactionDate)}
                    </span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Txn ID</span>
                    <span className="font-medium">{record.trans_id || "—"}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Type</span>
                    <span className="font-semibold">{record.type}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-slate-500">Pre Balance</p>
                      <p className="font-medium">₹ {record.preBalance}</p>
                    </div>
                    <div>
                      <p className="text-slate-500">Post Balance</p>
                      <p className="font-medium">₹ {record.postBalance}</p>
                    </div>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Txn Amount</span>
                    <span className="font-semibold">₹ {record.txnAmount}</span>
                  </div>

                  <div className="text-sm">
                    <p className="text-slate-500">Category</p>
                    <p className="font-medium">{record.category}</p>
                  </div>

                  <div className="text-sm">
                    <p className="text-slate-500">Narration</p>
                    <p className="font-medium break-words">{record.narration}</p>
                  </div>

                  <div className="rounded-xl bg-slate-200 p-4 text-sm font-semibold">
                    Total Txn Amount: ₹ {totalFilteredTxnAmount.toFixed(2)}
                  </div>

                </div>
              ))
            ) : (
              <p className="text-center py-6">No Records Found</p>
            )}
          </div>

          {/* ===== PAGINATION ===== */}
          {filteredRecords.length > recordsPerPage && (
            <div className="flex flex-col md:flex-row justify-between items-center gap-6 mt-8">
              <div className="flex items-center gap-4">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="px-5 py-2 rounded-xl bg-slate-200
                disabled:opacity-50"
                >
                  Previous
                </button>

                <span className="text-slate-700">
                  Page <strong>{currentPage}</strong> of{" "}
                  <strong>{totalPages}</strong>
                </span>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className="px-5 py-2 rounded-xl
                bg-gradient-to-r from-indigo-600 to-cyan-500
                text-white disabled:opacity-50"
                >
                  Next
                </button>
              </div>

              <p className="text-slate-600 text-sm">
                Showing <strong>{filteredRecords.length}</strong> records
              </p>
            </div>
          )}
        </div>
      </div>
      {hasMore && (
        <div className="flex justify-center mt-8">
          <button
            onClick={handleLoadMore}
            disabled={isHistoryLoading}
            className="px-8 py-3 rounded-xl
      bg-gradient-to-r from-indigo-600 to-cyan-500
      text-white font-semibold shadow-lg
      disabled:opacity-50"
          >
            {isHistoryLoading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}

    </div>
  );


};

export default RetailerCashiInReport;
